export default __webpack_public_path__ + "images/SN.4989fa9.png";